import * as React from 'react';
import { SVGProps } from 'react';
const SvgUserMusicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M57.333 57.333H6.667l2.165-8.382a13.764 13.764 0 0 1 13.596-11.618h19.143c6.773 0 12.54 4.928 13.596 11.618l2.166 8.382Z"
      fill="#004299"
    />
    <path
      d="M32 40a13.526 13.526 0 0 1-13.43-11.915l-.663-5.533C16.892 14.102 23.489 6.667 32 6.667c8.51 0 15.108 7.436 14.093 15.886l-.664 5.534A13.526 13.526 0 0 1 32 40Z"
      fill="#004299"
    />
    <path
      d="m8.667 5.333-1.5 4.5-4.5 1.5 4.5 1.5 1.5 4.5 1.5-4.5 4.5-1.5-4.5-1.5-1.5-4.5ZM55.333 29.333l-1.5 4.5-4.5 1.5 4.5 1.5 1.5 4.5 1.5-4.5 4.5-1.5-4.5-1.5-1.5-4.5Z"
      fill="#FFAB00"
    />
    <path
      d="M45.333 20h4A2.666 2.666 0 0 1 52 22.667v4a2.666 2.666 0 0 1-2.667 2.666h-4V20ZM18.667 29.333h-4A2.666 2.666 0 0 1 12 26.667v-4A2.666 2.666 0 0 1 14.667 20h4v9.333Z"
      fill="#2572ED"
    />
    <path
      d="M48 22.667h-2.667V20C44.712 13.21 38.977 8 32 8s-12.712 5.21-13.339 12.12l.006 2.547H16V20c.756-8.413 7.633-14.667 16-14.667s15.244 6.254 15.995 14.547L48 22.667Z"
      fill="#2572ED"
    />
    <path d="M48 20h-2.667v9.333H48V20ZM16 29.333h2.667V20H16v9.333Z" fill="#538DFF" />
  </svg>
);
export default SvgUserMusicIcon;
